/**
 * Ai 角色 create/edit 保存前字段变换：分类名→ID、版本列表等。
 */
import { AI_ASSISTANT_ASSET_TYPE } from './aiAssistantConstants'
import { normalizeAiRoleStringList } from './aiAssistantAdapter'

export function mapCategoryNamesToIds(categoryIdList, tagMap) {
  if (typeof categoryIdList === 'string') {
    return categoryIdList
  }
  return (categoryIdList || [])
    .map((name) => tagMap[name])
    .filter((id) => id != null && id !== '')
    .join(',')
}

export function splitNeglectVersion(value) {
  if (Array.isArray(value)) {
    return value
  }
  const parts = String(value || '').split(',').filter(Boolean)
  return parts.length ? parts : []
}

export function setAppVersion(data) {
  const list = JSON.parse(JSON.stringify(data || []))
  for (let i = list.length - 1; i >= 0; i -= 1) {
    // 空字符串 split 会得到 ['']，filter(Boolean) 避免把空 skip 传给后端
    list[i].skip = String(list[i].skip || '').split(',').filter(Boolean)
    if (list[i].dataSetId != '0' && !list[i].dataSetId) {
      list.splice(i, 1)
    }
  }
  return list
}

export function getAppVersion(data) {
  return (data || []).map((element) => ({
    ...element,
    skip: Array.isArray(element.skip) ? element.skip.join(',') : element.skip,
  }))
}

/**
 * 合并 unlockData 并构建 WallpaperCo 保存体。
 */
export function buildAiAssistantSavePayload(ruleForm, unlockData, options = {}) {
  const form = { ...ruleForm }
  Object.assign(form, unlockData)
  form.dataSetLockGroupList = (form.dataSetLockGroupList || []).filter(
    (row) => row.lockGroupId !== '' && row.dataSetId !== ''
  )

  const jsonConfig = form.jsonConfig || {}
  const aiRole = { ...(jsonConfig.aiRole || {}) }
  aiRole.welcome = normalizeAiRoleStringList(aiRole.welcome)
  aiRole.starters = normalizeAiRoleStringList(aiRole.starters)

  const payload = {
    ...form,
    wallpaperName: form.resourceName || form.wallpaperName || '',
    wallpaperType: AI_ASSISTANT_ASSET_TYPE,
    thumbUrl: aiRole.avatar || form.thumbUrl || '',
    jsonConfig: {
      ...jsonConfig,
      aiRole,
    },
    appVersionDataSetList: setAppVersion(form.wallpaperAppVersionList),
    tagKeySet: (form.tagVOList || []).map((tag) => tag.key),
    wallpaperUrlList: [],
    wallpaperUrlListAndroid: [],
  }

  if (options.id != null) {
    payload.id = options.id
  }

  return payload
}

export function toAiAssistantFormData(payload) {
  const form = new FormData()
  form.append('dataJson', JSON.stringify({ WallpaperCo: payload }))
  return form
}
